import {Box} from "@mui/system"
import {CSSProperties, type FC} from "react"
import {ArticleChevronIcon} from "../../../assets"

type Props = {
  title: string
  style: CSSProperties
  themeColor: string | undefined
  boxStyle?: CSSProperties
  titleStyle?: CSSProperties
}

const DiscoverMainItem: FC<Props> = (props) => {
  const {title, style, themeColor, boxStyle, titleStyle} = props
  return (
    <Box style={{...style}} display={"flex"} position={"absolute"}>
      <Box
        display={"flex"}
        flexDirection={"row"}
        alignItems={"center"}
        gap={1.5}
        style={{height: "100%", paddingLeft: "13px"}}
      >
        <ArticleChevronIcon fill={themeColor} height={"55px"} />
        <Box
          style={{
            backgroundColor: themeColor,
            ...boxStyle,
          }}
        >
          <span
            style={{
              boxDecorationBreak: "clone",
              WebkitBoxDecorationBreak: "clone",
              ...titleStyle,
            }}
          >
            {title}
          </span>
        </Box>
      </Box>
    </Box>
  )
}

export default DiscoverMainItem
